import { useCallback, useState } from 'react'

import { useTranslation } from 'react-i18n-lite'

import { useTheme } from 'styled-components'

import useTextFading from './hooks/useTextFading'

import { FadeOverlay, Marquee, MarqueeContainer } from './TextFading.styles'

import { TextFadingType } from './type'

function TextFading({ children, marqueeTransitionSpeed = 15 }: TextFadingType) {
  const {
    transitionTime,
    translateValue,
    direction,
    showRightFade,
    showLeftFade,
    containerRef,
    marqueeRef,
    checkPosition
  } = useTextFading({ marqueeTransitionSpeed })

  const { t } = useTranslation()

  const theme = useTheme()

  const [containerBackgroundColor, setContainerBackgroundColor] = useState(
    theme?.colors?.defaultBackground
  )

  const getContainerRef = useCallback(
    (element: HTMLDivElement | null) => {
      if (element) {
        const computedStyle = window.getComputedStyle(element)

        if (
          !['transparent', 'rgba(0, 0, 0, 0)'].includes(
            computedStyle.backgroundColor
          )
        ) {
          setContainerBackgroundColor(computedStyle.backgroundColor)
        }

        containerRef.current = element
      }
    },
    [containerRef]
  )

  return (
    <MarqueeContainer ref={getContainerRef}>
      {showLeftFade && (
        <FadeOverlay
          side='left'
          parentBackground={containerBackgroundColor}
          aria-label={t('text-fading.read-less')}
        />
      )}

      <Marquee
        ref={marqueeRef}
        transitionTime={transitionTime}
        translateValue={translateValue}
        direction={direction}
        role='marquee'
        onTransitionEnd={checkPosition}
        shouldTransform={showRightFade || showLeftFade}
      >
        {children}
      </Marquee>

      {showRightFade && (
        <FadeOverlay
          side='right'
          parentBackground={containerBackgroundColor}
          aria-label={t('text-fading.read-more')}
        />
      )}
    </MarqueeContainer>
  )
}

export default TextFading
